function initTheme(root=document){
  const scope=root instanceof Element ? root : document;
  if (!document.body.classList.contains('shopify-design-mode')) {
    if ('IntersectionObserver' in window) {
      const obs=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');obs.unobserve(e.target)}}),{threshold:.12});
      scope.querySelectorAll?.('.reveal:not(.visible)').forEach(el=>obs.observe(el));
    } else {
      scope.querySelectorAll?.('.reveal').forEach(el=>el.classList.add('visible'));
    }
  } else {
    scope.querySelectorAll?.('.reveal').forEach(el=>el.classList.add('visible'));
  }
  const lb=document.getElementById('lightbox');
  if(lb && !lb.dataset.bound){
    lb.dataset.bound='1';
    const im=lb.querySelector('img');
    const close=()=>{lb.classList.remove('open');lb.setAttribute('aria-hidden','true');if(im)im.src=''};
    lb.querySelector('.lightbox-close')?.addEventListener('click',close);
    lb.addEventListener('click',e=>{if(e.target===lb)close()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  }
  scope.querySelectorAll?.('.preview-card:not([data-bound])').forEach(b=>{
    b.dataset.bound='1';
    b.addEventListener('click',()=>{const light=document.getElementById('lightbox'); if(!light)return; const im=light.querySelector('img'); if(im)im.src=b.dataset.img; light.classList.add('open'); light.setAttribute('aria-hidden','false')});
  });
}
document.addEventListener('DOMContentLoaded',()=>initTheme(document));
document.addEventListener('shopify:section:load',e=>initTheme(e.target));
document.addEventListener('shopify:section:select',e=>{e.target.querySelectorAll?.('.reveal').forEach(el=>el.classList.add('visible'));});
